import { render, staticRenderFns } from "./DateText.vue?vue&type=template&id=2f327829&scoped=true"
import script from "./DateText.vue?vue&type=script&lang=js"
export * from "./DateText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f327829",
  null
  
)

export default component.exports